import { GiftOutlined, MenuOutlined } from '@ant-design/icons';
import { Badge, Button, Dropdown, Flex, Layout, Space, Typography } from 'antd';
import { useSelector } from 'react-redux';
import { getRoleByValue, handleLogout } from '../../../../utils';
import UserAvatar from '../../../ui/UserAvatar';
import Branding from './../../../ui/Branding';
import ResponsiveMenu from './ResponsiveMenu';
import { Activity, useState } from 'react';
import GlobalSearch from '../../../ui/GlobalSearch';
import { Bell } from 'lucide-react';
import Notifications from '../../../ui/Notifications';
import { ROLES } from '../../../../routes/Routes';

const { Header } = Layout;

const PrivateHeader = ({ notifications }) => {
    const { user } = useSelector((state) => state.authSlice);
    const [open, setOpen] = useState(false);

    const renderUserProfile = () => (
        <Flex align="center" gap={10} onClick={(e) => e.stopPropagation()}>
            <UserAvatar user={user} size={40} />
            <Space direction="vertical" size={0}>
                <Typography.Text strong>{user?.name}</Typography.Text>
                <Typography.Text type="secondary">
                    {user?.email ?? getRoleByValue(user?.role)}
                </Typography.Text>
            </Space>
        </Flex>
    );

    const items = [
        {
            key: 'profile',
            label: renderUserProfile(),
        },
        {
            type: 'divider',
        },
        {
            key: 'logout',
            label: (
                <Flex justify="center">
                    <Button type="link" danger>
                        Logout
                    </Button>
                </Flex>
            ),
            onClick: handleLogout,
        },
    ];

    return (
        <Header className="app-header px-4">
            <Branding />
            <GlobalSearch />
            <Flex align="center" gap={10} className="header-actions">
                <Button type="primary" icon={<GiftOutlined />} className="offer-button">
                    Exclusive Offers
                </Button>
                <Activity mode={[ROLES.ADMIN, ROLES.SUPER_ADMIN].includes(user?.role) ? 'visible' : 'hidden'}>
                    <Dropdown
                        popupRender={() => <Notifications count={notifications} />}
                        trigger={['click']}
                        placement="bottomRight"
                    >
                        <Badge dot={!!notifications} offset={[-3, 5]}>
                            <Button icon={<Bell size={16} />} variant='filled' shape='round' color='primary' className='flex' />
                        </Badge>
                    </Dropdown>
                </Activity>
                <Dropdown
                    menu={{
                        items,
                    }}
                    trigger={['click']}
                    className="user-info"
                >
                    <div>
                        <UserAvatar user={user} size={40} />
                    </div>
                </Dropdown>
            </Flex>
            <Button icon={<MenuOutlined />} className="responsive-menu" onClick={() => setOpen(true)} />
            <Activity mode={open ? 'visible' : 'hidden'}>
                <ResponsiveMenu profile={renderUserProfile} open={open} onClose={() => setOpen(false)} />
            </Activity>
        </Header>
    );
};

export default PrivateHeader;
